export default "__VITE_ASSET__fa2132bc__"